import { render, staticRenderFns } from "./manageGoods1222.vue?vue&type=template&id=34349dab&scoped=true&"
import script from "./manageGoods1222.vue?vue&type=script&lang=js&"
export * from "./manageGoods1222.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1222.vue?vue&type=style&index=0&id=34349dab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34349dab",
  null
  
)

export default component.exports